/**
 * Umi 全局路由懒加载 loading
 */
import React from "react";
import PageLoading from "@/components/PageLoading";

export default () => <PageLoading fullscreen />;
